enum Colors {
  Blue50 = "#ecf7ff",
  Blue100 = "#c4e5ff",
  Blue200 = "#a7d9ff",
  Blue300 = "#7fc7ff",
  Blue400 = "#66bdff",
  Blue500 = "#40acff",
  Blue600 = "#3a9de8",
  Blue700 = "#2d7ab5",
  Blue800 = "#235f8c",
  Blue900 = "#1b486b",

  Purple50 = "#f3efff",
  Purple100 = "#dacfff",
  Purple200 = "#c8b7ff",
  Purple300 = "#af96ff",
  Purple400 = "#a082ff",
  Purple500 = "#8863ff",
  Purple600 = "#7c5ae8",
  Purple700 = "#6146b5",
  Purple800 = "#4b368c",
  Purple900 = "#392a6b",

  Gray50 = "#fefefe",
  Gray100 = "#fcfcfd",
  Gray200 = "#fafafb",
  Gray300 = "#f8f8fa",
  Gray400 = "#f7f7f9",
  Gray500 = "#f5f5f7",
  Gray600 = "#dfdfe1",
  Gray700 = "#aeaeaf",
  Gray800 = "#878788",
  Gray900 = "#676768",

  Black50 = "#e9e9e9",
  Black100 = "#bcbcbc",
  Black200 = "#9c9c9c",
  Black300 = "#6e6e6e",
  Black400 = "#525252",
  Black500 = "#272727",
  Black600 = "#232323",
  Black700 = "#1c1c1c",
  Black800 = "#151515",
  Black900 = "#101010",

  Bg300 = "#fefeff",
  Bg2100 = "#fdfdff",
  Bg2200 = "#fbfcff",
  Bg2300 = "#fafaff",
  Bg2400 = "#f9f9ff",
  Bg2500 = "#f7f8ff",
  Bg2600 = "#e1e2e8",
  Bg2700 = "#afb0b5",
  Bg2800 = "#88888c",
  Bg2900 = "#68686b",

  Green100 = "#BDF5C3",
  Green500 = "#6EDE7B",

  Red100 = "#fac0c9",
  Red500 = "#FF5069",

  Gradient100 = "linear-gradient(45deg, #40ACFF 0%, #8863FF 88%)",
}

const ThemeColors: Record<keyof typeof Colors, string> = Colors;

export default ThemeColors;
